<script setup lang="ts">
  import { computed } from 'vue';
  import { useBreakpoint } from '@/shared/model';
  import {
    UserGridItemPortrait,
    useGetRandomizedRecommendedUsersQuery,
  } from '@/entities/user';
  import { useChainBehavior } from '@/entities/user-setting';
  import type { RandomizedRecommendationQuery } from 'dfx/edge/edge.did';

  const props = withDefaults(
    defineProps<{
      count?: number;
    }>(),
    {
      count: 3,
    },
  );

  const { contentPreset } = useChainBehavior();
  const queryParams = computed<RandomizedRecommendationQuery>(() => ({
    filter_tags: [['feed-recs']],
    count: props.count,
    content_preset: contentPreset.value,
  }));

  const { data: peopleFeedRecommendations } =
    useGetRandomizedRecommendedUsersQuery(queryParams);
  const { isSmallerThanSm } = useBreakpoint();

  const list = computed(() => {
    return isSmallerThanSm.value
      ? peopleFeedRecommendations.value?.slice(0, 2)
      : peopleFeedRecommendations.value;
  });
</script>

<template>
  <ul class="grid grid-cols-2 sm:grid-cols-3 gap-4 py-0 mt-4">
    <li v-for="user in list" :key="user.username">
      <user-grid-item-portrait :user="user" />
    </li>
  </ul>
</template>
